import axios from 'axios'
import Constantes from '../../utils/constantes'
import Alert from '../../utils/alert'

const state = {
    empresas: [],
    filiais: [],
    filial: null
}

// getters
const getters = {
    empresas(state) {
        return state.empresas
    },
    filiais(state) {
        return state.filiais
    },
    filial(state) {
        return state.filial
    },
}

// actions
const actions = {
    carregarEmpresas({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: `${Constantes.URL_SERVIDOR}/empresa/listall`
            }).then(
                result => {
                    // if (result.data !== '') {
                    commit('setEmpresas', result.data)

                    // } else {
                    //     commit('core/setError', { message: 'Erro ao carregar Empresas.' }, { root: true })
                    // }
                    // commit('core/setLoading', false, { root: true })
                    resolve()
                },
                error => {
                    console.error(error)
                    commit('core/setError', error, { root: true })
                    commit('core/setLoading', false, { root: true })
                    reject()
                }
            )
        })
    },
    carregarFiliais({ commit }, payload) {
        axios({
            method: 'GET',
            // url: `${Constantes.URL_SERVIDOR}/empresa/filiais?empIntCod=${payload}`
            url: `${Constantes.URL_SERVIDOR_IS}/filial/filiais/${payload}`
        }).then(
            result => {
                commit('setFiliais', result.data)
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    },
    buscarFilialProxima({ commit }, payload) {
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR_IS}/filial/buscarfilialmaisproxima/${payload.empIntCod}/${payload.cep}`
        }).then(
            result => {
                commit('setFilial', result.data)
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    }
}

// mutations
const mutations = {
    setEmpresas(state, payload) {
        state.empresas = payload
    },
    setFiliais(state, payload) {
        state.filiais = payload
    },
    setFilial(state, payload) {
        state.filial = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
